// extracted by mini-css-extract-plugin
export default {"root":"app-portainer-components-BoxSelector-BoxSelector-module__root"};